import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      position: "relative",
      display: "inline-block",
    },
    inner: {
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      top: "100%",
      right: 0,
      background: theme.background,
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      borderRadius: constants.radius.view,
      padding: spacing.xs,
      minWidth: 340,
      zIndex: 100,
    },
    item: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      userSelect: "none",
      cursor: "pointer",
      padding: spacing.m,
      width: 300,
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.view,
      marginBottom: spacing.xs,
    },
    text: {
      marginLeft: spacing.s,
      display: "flex",
      flexDirection: "column",
    },
  };

  return styles;
};
